export const TestId = {
  root: 'ProfileImage',
  fileInput: 'ProfileImage.fileInput',
  image: 'ProfileImage.image',
  addButton: 'ProfileImage.addButton',
  changeButton: 'ProfileImage.changeButton',
  removeButton: 'ProfileImage.removeButton',
}
